/**
 * White-label display scrubbing — visual strings only.
 * Internal keys, API payloads, copied CLI commands, and routing stay unchanged.
 */
import {
  BRAND_NAME,
  SKILLS_REGISTRY_DISPLAY_NAME,
} from "./branding.ts";

export function scrubVendorBrandingForDisplay(text: string): string {
  if (!text) {
    return text;
  }
  let out = text;
  out = out.replace(/ClawHub/g, SKILLS_REGISTRY_DISPLAY_NAME);
  out = out.replace(/Open\s*Claw/gi, BRAND_NAME);
  out = out.replace(/openclaw\.json/gi, "gateway configuration");
  out = out.replace(/OPENCLAW_/g, "JARVIS_");
  out = out.replace(/\bopenclaw\b/gi, "jarvis");
  return out;
}

export function formatAssistantNameForDisplay(name: string): string {
  const trimmed = name.trim();
  if (!trimmed) {
    return trimmed;
  }
  if (/^open\s*claw$/i.test(trimmed) || /^openclaw$/i.test(trimmed)) {
    return BRAND_NAME;
  }
  return scrubVendorBrandingForDisplay(trimmed);
}

export function scrubCliCommandForDisplay(command: string): string {
  return scrubVendorBrandingForDisplay(command);
}
